function featureWeekSpeakersFn() {
	const fwSpeakers = document.querySelectorAll('.feature-week-guest');
	fwSpeakers.forEach(function(fwSpeaker) {
		const fwImage = fwSpeaker.querySelector('.feature-week-guest-image');
		const fwBio = fwSpeaker.querySelector('.feature-week-guest-bio');
		const fwBioCloser = fwSpeaker.querySelector('.feature-week-guest-bio .close');

		if (fwImage !== null) {
			fwImage.addEventListener('click', function() {
				fwBio.classList.toggle('active');
			});

			fwBioCloser.addEventListener('click', function() {
				fwBio.classList.remove('active');
			});
		}
	});
}

const featureWeekSpeakers = {
	init: function() {
		featureWeekSpeakersFn();
	},
};

export default featureWeekSpeakers;
